/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 */

import { useEffect, useState } from "react";
import { supabase } from "../utils/supabaseClient.js";
import { getMyPrimaryAccount } from "../utils/accountService.js";

// The role label to show under the user's name. Prefers a Brand Command staff
// role (platform_admins: superadmin/support) over the tenant role
// (account_members: owner/admin/member). Returns the raw role string so new
// roles surface automatically; the UI capitalizes it.
export function useUserRole() {
  const [role, setRole] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) return;

        // Staff role first (RLS returns only the caller's own row).
        const { data: staff } = await supabase
          .from("platform_admins")
          .select("role")
          .eq("user_id", user.id)
          .maybeSingle();
        if (staff?.role) {
          if (alive) setRole(staff.role);
          return;
        }

        // Otherwise the role in their primary workspace.
        const acct = await getMyPrimaryAccount();
        if (alive) setRole(acct?.role ?? null);
      } catch {
        /* non-fatal — just don't show a role */
      }
    })();
    return () => { alive = false; };
  }, []);

  return role;
}
